import { Pipe, PipeTransform } from "@angular/core";
import { parsePhoneNumber } from 'libphonenumber-js';
import { CountryCode } from 'libphonenumber-js';

@Pipe({name: 'formatPhone'}) // log variable into the console

export class PhonePipe implements PipeTransform {
    transform(phone: any, countryCode = "GB") {
        try {
            const phoneNumber = parsePhoneNumber(phone, countryCode as CountryCode);

            if (phoneNumber.isValid()) {
                return phoneNumber.formatInternational();
            }
            return phone;
        } catch (err) {
        }
        return phone;
    }
}
